import { useEffect } from 'react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Register the worker and reload as soon as a new version takes control.
//
// The worker calls skipWaiting() on install, so an update does not wait for the
// user to close every tab - which on Android may never happen, because an
// installed PWA is usually resumed instead of relaunched. Reloading is what
// switches the page from the old JavaScript bundle to the new one; without it
// the old page would keep running while the new worker serves the new index.
export const useServiceWorker = () => {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return undefined;
    }

    // The first ever install also fires `controllerchange` when it claims the
    // page. There is no previous build to move away from, so don't bounce a
    // brand new visitor.
    const hadController = Boolean(navigator.serviceWorker.controller);
    let reloading = false;

    const onControllerChange = () => {
      if (!hadController || reloading) {
        return;
      }
      reloading = true;
      window.location.reload();
    };

    // Attach before registering: the swap can complete while register() is
    // still resolving.
    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
    serviceWorkerRegistration.register();

    return () => {
      navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
    };
  }, []);
};
